export default "__VITE_ASSET__BdWs0Yym__"